import React from "react";
//import Question from "./components/questionComponent";
//import Login from "./components/login";
import RouteComponent from "./components/routeComponent";

function App() {
  console.log("from app.js");
  return <RouteComponent />;
}

export default App;
